import * as CubeTree from '../../cubeTree/index';

function makeUpdateTaskQueue(cubes: Array<CubeId>, surface: number): Array<UpdateTask> {
    let result: Array<UpdateTask> = [];

    cubes.forEach((cubeId: CubeId): void => {
        CubeTree.isGoods(cubeId) && result.push({
            cubeId,
            updateData: {
                surfaceWidth: surface
            }
        });
    });

    return  result;
}

function findUpdateTargets(cubeIds: CubeId[]): CubeId[] {
    let result: Set<CubeId> = new Set();

    cubeIds.forEach((cubeId: CubeId): void => {
        if (CubeTree.isInStage(cubeId)) {
            result.add(cubeId);
            return;
        }

        let itsLayer: CubeId = CubeTree.findCubeLayer(cubeId);

        result.add(itsLayer);
    });

    return Array.from(result);
}

export {
    makeUpdateTaskQueue,
    findUpdateTargets
};
